import { Api } from 'api';

export function useDefaultLagDate() {
  const { data, isLoading } = Api.admin.GetAdminSettings();

  return { defaultLagDate: data?.defaultLagDate, isLoading };
}
